module.exports = __webpack_public_path__ + "72916a399ed6aff604e3a269a366b3b3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/sophiebysophie.svg
// module id = 213
// module chunks = 0